import { apiService } from "./apiService";
import Swal from "sweetalert2";

export function fetchVirtualCardUsers(data) {
    return apiService({
        method: "POST",
        url: "/api/virtual-card/admin/cardholders",
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function fetchVirtualCards(data) {
    return apiService({
        method: "POST",
        url: "/api/virtual-card/admin/cards",
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function getVirtualCardUserById(id) {
    return apiService({
        method: "GET",
        url: "/api/virtual-card/admin/cardholders/" + id,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function updateVirtualCardUser(id, data) {
    return apiService({
        method: "POST",
        url: "/api/virtual-card/admin/cardholders/" + id + "/process",
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: (dispatch, error) => {
            const errorMessage =
                error?.message || "Failed to update virtual card user";
            Swal.fire({
                icon: "error",
                title: "Error",
                text: errorMessage,
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
            });
        },
    });
}

export function updateFreezeVirtualCard(data) {
  return apiService({
    method: "POST",
    url: "/api/virtual-card/admin/freeze-card",
    data,
    onSuccess: (dispatch, res) => {},
    onFailure: () => {},
  });
}

export function updateUnfreezeVirtualCard(data) {
  return apiService({
    method: "POST",
    url: "/api/virtual-card/admin/unfreeze-card",
    data,
    onSuccess: (dispatch, res) => {},
    onFailure: () => {},
  });
}

export function deleteUserVirtualCard(data) {
  return apiService({
    method: "POST",
    url: "/api/virtual-card/admin/delete-card",
    data,
    onSuccess: (dispatch, res) => {},
    onFailure: () => {},
  });
}
